import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { Box } from '@mui/material';
import { useLocalContext } from '../../context/Context';
import EnrollClass from '../../components/enrollClass/EnrollClass';
import BookDemoPopup from '../../components/bookDemo/BookDemoPopup';
import { Link, useNavigate } from 'react-router-dom';

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

const CourseCard = ({ course }) => {
  const navigate = useNavigate()
  const { joinClassDialog, setJoinClassDialog} = useLocalContext()
  const [openDialog2, setOpenDialog2] = useState(false)
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const courseId = course.id

  const {
    name,
    start_date,
    end_date,
    test_type_id,
    creator_name,
    price,
    level,
    mode_of_delivery,
    seat_availability,
    day_left,
    start_time,
    end_time
  } = course;

  const handleOpenDialog1 = () => {
    setJoinClassDialog(true);
  };

  const handleCloseDialog1 = () => {
    setJoinClassDialog(false);
  };

  const handleOpenDialog2 = () => {
    setOpenDialog2(true);
  };

  const handleCloseDialog2 = () => {
    setOpenDialog2(false);
  };

  const handleEnrollClick = () => {
    navigate(`/course/${courseId}`);
  };

  return (
    <Box>
      <Card sx={{ maxWidth: 345, flex: '1 1 345px', margin: '10px' }}>
        <CardHeader
          avatar={
            <Avatar sx={{ bgcolor: red[500] }} aria-label="teacher">
              {creator_name}
            </Avatar>
          }
          action={
            <IconButton aria-label="settings">
              <MoreVertIcon />
            </IconButton>
          }
          title={name}
          subheader={test_type_id}
        />
       {/* <CardMedia component="img" height="194"  alt={name} /> */}
       <CardContent>
            <Typography paragraph>Mode of Delivery: {mode_of_delivery}</Typography>
            <Typography paragraph>Level: {level}</Typography>
            <Typography variant="body1" color="error" paragraph>
              Days Left: {day_left} remaining
            </Typography>
            <Typography variant="body2" color="error" paragraph>
              Available: {seat_availability} spaces left
            </Typography>
            <Typography paragraph>Price: ${price}</Typography>
          </CardContent>
        <CardActions disableSpacing>
          <IconButton aria-label="add to favorites">
            <FavoriteIcon />
          </IconButton>
          <IconButton aria-label="share">
            <ShareIcon />
          </IconButton>
          <ExpandMore
            expand={expanded}
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
          >
            <ExpandMoreIcon />
          </ExpandMore>
        </CardActions>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent>
            <Typography paragraph>Start Date: {start_date}</Typography>
            <Typography paragraph>End Date: {end_date}</Typography>
          </CardContent>
        </Collapse>
        <CardActions>
        <Button variant="contained" color="primary" onClick={handleOpenDialog2}>
          Book Demo
        </Button>
      </CardActions>
      <CardActions>
        <Button variant="contained" color="primary" onClick={handleEnrollClick}>
          Enroll
        </Button>
      </CardActions>
      </Card>
      <EnrollClass open={joinClassDialog} onClose={handleCloseDialog1}/>
      <BookDemoPopup open={openDialog2} onClose={handleCloseDialog2} courseId={courseId}/>
      </Box>
    
  );
};

export default CourseCard;




